"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function instanceOfFormField(object) {
    return 'model' in object;
}
exports.instanceOfFormField = instanceOfFormField;
function instanceOfValueFormField(object) {
    return 'indexField' in object;
}
exports.instanceOfValueFormField = instanceOfValueFormField;
function instanceOfButtonFormField(object) {
    return 'buttonField' in object;
}
exports.instanceOfButtonFormField = instanceOfButtonFormField;
function instanceOfFormFieldSection(object) {
    return 'fields' in object;
}
exports.instanceOfFormFieldSection = instanceOfFormFieldSection;
